import styles from "./gridSection.module.css";
import { useEffect, useRef } from "react";
import parallax from "../parallax";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

const GridSection = () => {
  const box1 = useRef(null);
  const ctn = useRef(null);
  const box2 = useRef(null);
  const box3 = useRef(null);
  useEffect(() => {
    parallax(
      {
        trigger: ctn.current,
        start: "top bottom",
        end: "top top",
        scrub: true,
      },
      [box1.current, box2.current, box3.current]
    );
  }, []);
  return (
    <div ref={ctn} className={styles.ctn}>
      <div ref={box1} className={styles.box1}>
        <div>
          <img src="./img.png" alt="" data-parallax="true" />
        </div>

        <h5>这是文字这是文字这是文字这是文字这是文字这是文字</h5>
      </div>

      <div ref={box2} className={styles.box2}>
        <div>
          <img src="./img.png" alt="" data-parallax="true" />
        </div>

        <h5>这是文字这是文字这是文字这是文字这是文字这是文字</h5>
      </div>

      <div ref={box3} className={styles.box3}>
        <h5>这是文字这是文字这是文字这是文字这是文字这是文字</h5>
        <div>
          <img src="./img.png" alt="" data-parallax="true" />
        </div>
      </div>

      <div className={styles.background}></div>
    </div>
  );
};

export default GridSection;
